import ServiceHero from "../../../components/elements/service-hero";
import FeatureStrip from "../../../components/elements/feature-strip";
import ServicePageLayout from "../../../components/elements/service-page-layout";
import SectionTitle from "../../../components/elements/section-title";
import { PricingCardFlex } from "../../../components/elements/pricing-card";
import CTA from "../../../components/elements/CTA";
import "../ep-courses-and-services-pages.css";
import "./index-producao-textual-vestibulares.css";

const steps = [
  ["01", "Entenda", "Conheça a proposta e os critérios relevantes."],
  ["02", "Pratique", "Produza textos com orientação."],
  ["03", "Receba feedback", "Entenda seus pontos fortes e o que melhorar."],
  ["04", "Evolua", "Aplique as orientações nas próximas produções."],
];

const features = [
  ["▤", "Método prático e objetivo"],
  ["☼", "Acompanhamento individual"],
  ["♧", "Foco nos critérios de cada vestibular"],
  ["▥", "Desenvolvimento do seu potencial"],
  ["☏", "Mais confiança e resultados"],
];

export default function ProducaoTextualVestibulares() {
  return (
    <>
      <ServiceHero
        eyebrow="produção textual para vestibulares"
        title={
          <>
            Domine a escrita e conquiste sua <em>vaga na universidade.</em>
          </>
        }
        description="Aulas e orientações personalizadas para você desenvolver suas habilidades de produção textual e alcançar altas notas nos principais vestibulares do país."
        image="/images/producao-textual-vestibulares-hero.png"
        // quote="Mais do que uma nota, é o seu futuro!"
      />

      <main>
        <div className="container service-body">
          <FeatureStrip
            items={features.map(([icon, label]) => ({ icon, label }))}
          />
          <div className="two-col" id="como-funciona">
            <section className="paper-panel">
              <SectionTitle title="O que você vai desenvolver?" />
              <ul className="check-list">
                <li>Estrutura e organização do texto;</li>
                <li>Argumentação sólida e repertório sociocultural;</li>
                <li>Coesão e coerência textual;</li>
                <li>Estratégias para a prova;</li>
                <li>Simulados e correções com feedback.</li>
              </ul>
              {/* <p className="hand-note">
                Seu esforço de hoje é o seu resultado de amanhã!
              </p> */}
            </section>
            <section className="paper-panel">
              <SectionTitle title="Nossos planos" />
              <div className="mentoring-pricing-list">
                <PricingCardFlex
                  title="Plano Essencial"
                  tag="4 textos"
                  price="149,90"
                  unit="/ hora"
                  features={[
                    "Diagnóstico inicial",
                    "Plano de estudos personalizado",
                    "Acompanhamento semanal",
                  ]}
                />
                <PricingCardFlex
                  title="Plano Avançado"
                  tag="8 textos"
                  price="249,90"
                  features={[
                    "Tudo do plano essencial",
                    "Revisão de textos",
                    "Estratégias de prova",
                    "Suporte por WhatsApp ou e-mail",
                  ]}
                />
                <PricingCardFlex
                  title="Plano Premium"
                  tag="12 textos"
                  price="349,90"
                  features={[
                    "Tudo do plano avançado",
                    "Correções extras de textos",
                    "Simulados e direcionamento",
                    "Acompanhamento completo",
                    "Acompanhamento de suas evolução",
                  ]}
                />
              </div>
            </section>
          </div>

          <CTA
            title="Sua evolução começa com "
            titleBr="um passo: o primeiro contato."
            subtitle="Vamos conversar sobre seus objetivos?"
            button="QUERO AGENDAR MINHA MENTORIA"
            href=""
          />

          {/* <div className="ep-service-steps">
                  {steps.map(([number, stepTitle, text]) => (
                    <div className="ep-service-step" key={number}>
                      <div className="ep-service-step-number">{number}</div>
                      <h3>{stepTitle}</h3>
                      <p>{text}</p>
                    </div>
                  ))}{" "}
                </div> */}

          <section className="why">
            <SectionTitle
              align="center"
              title="Ideal para quem busca:"
            />
            <div className="why-grid">
              {[
                "Organização e foco nos estudos",
                "Aprimorar a escrita e a argumentação",
                "Preparação para ENEM, vestibulares e concursos",
                "Mais confiança e segurança",
              ].map((x, i) => (
                <div key={i}>
                  <b>{["♧", "▤", "☆", "☏"][i]}</b>
                  <span>{x}</span>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </>
  );
}
